import { translate } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { getPhoneConfig } from '@gig/magic-jurisdictions/dist/sign-up-form-config';
import '../../../../config/email-config.js';
import '../../../../config/progress-bar-config.js';
import '../../../../config/first-name-config.js';
import '../../../../config/last-name-config.js';
import '../../../../config/address-config.js';
import '../../../../config/city-config.js';
import '../../../../config/country-config.js';
import '../../../../config/post-code-config.js';
import '../../../../config/currency-config.js';
import { phone } from '../../../../config/phone-config.js';
import '../../../../config/consent-config.js';
import '../../../../config/username-config.js';
import '../../../../config/state-config.js';
import '../../../../config/nested-consent-config.js';

function getConfigureOtpForm(phoneNumber, errorMessage, messageType) {
    return __awaiter(this, void 0, void 0, function () {
        var config, phoneField;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getPhoneConfig()];
                case 1:
                    config = _a.sent();
                    return [4 /*yield*/, phone(config)];
                case 2:
                    phoneField = _a.sent();
                    phoneField.properties.value = phoneNumber;
                    return [2 /*return*/, [
                            {
                                name: 'step-1',
                                path: 'step-1',
                                components: [phoneField],
                                nextButton: {
                                    text: translate('configure-otp.button'),
                                    alwaysEnabled: true,
                                },
                                errorMessage: errorMessage,
                                alwaysShowErrorMessage: messageType === 'error',
                            },
                        ]];
            }
        });
    });
}

export { getConfigureOtpForm };
